/**
 * @param {Filtrator} filtrator
 * @param {RowSelection} selection
 */
export function linkFiltratorSelection(filtrator, selection){
    filtrator.onRefresh.subscribe(selection.listRefreshed)

}